import { memo } from 'react'
import InfoIcon from './BountyContent.info'
import BountySubtitle from '../Bounty.subtitle'
import GrabButton from '../GrabButton/GrabButton'
import {
  BountyTitle,
  CountdownTimerWrapper,
  FooterWrap,
  HeaderWrap,
  SubtitleContainer,
  TitleWrap,
  Wrapper,
} from './BountyContent.styled'
import CountdownTimer from '@src/components/Elements/CountdownTimer'
import BountyCount from './BountyCount'
import BountyBorder from '../Bounty.border'
import AlreadyGrabbedOverlay from '../Bounty.grabbed'
import { getBorderColor } from './BountyContent.utils'
import StarRating from './BountyContent.star'
import { BountyStatus } from '@src/context/BountiesContext'
import { BountiesContextQuery$data } from '@src/context/__generated__/BountiesContextQuery.graphql'
import { useIntercom } from '@src/hooks/useIntercom'
import { WebpLazyImage } from '@src/components/WebpLazyImage/WepbLazyImage'

type BountyType = BountiesContextQuery$data['listBounties'][number]
export interface BountyContentProps extends Partial<BountyType> {
  disabled: boolean
  onInfoClick?: () => void
  onGrabClick?: () => void
  showOnlyInfo?: boolean
  buttonText?: string
  availableBountiesCount?: number | null
  bgImageUrl?: string
  expires?: string | null
}

export const BountyContent = ({
  bgImageUrl,
  buttonText = 'Grab',
  title,
  subtitle,
  rating,
  disabled,
  expires,
  showOnlyInfo,
  onInfoClick,
  onGrabClick,
  availableBountiesCount,
  status,
}: BountyContentProps) => {
  const borderColor = getBorderColor(disabled, bgImageUrl)
  const isOverlay = status === BountyStatus.ACTIVE_BUT_BONUS_EXISTS
  const { showIntercomArticle } = useIntercom()

  const infoClick = () => {
    showIntercomArticle(10549162)
  }

  return (
    <Wrapper $color={borderColor} $isOverlay={isOverlay} $disabled={disabled}>
      <WebpLazyImage src={bgImageUrl || 'https://cdn.blackjack.fun/optimized/bounties/level5.webp'} className="bg" />
      <BountyBorder color={borderColor} disabled={disabled} />
      <HeaderWrap className="bounty-header-wrapper">
        <InfoIcon onClick={infoClick} showOnlyInfo={showOnlyInfo} disabled={disabled} />
        <StarRating rating={rating} disabled={disabled} />
        <BountyCount disabled={disabled} showOnlyInfo={showOnlyInfo} count={availableBountiesCount} />
      </HeaderWrap>

      <TitleWrap className="bounty-title-wrapper">
        <BountyTitle $disabled={disabled}>{title}</BountyTitle>
        <CountdownTimerWrapper $disabled={disabled}>
          <CountdownTimer expiresAt={expires} />
        </CountdownTimerWrapper>
        <SubtitleContainer disabled={disabled}>
          <BountySubtitle subtitle={subtitle} />
        </SubtitleContainer>
      </TitleWrap>

      <AlreadyGrabbedOverlay disabled={disabled} />

      <FooterWrap className="bounty-footer-wrapper">
        <GrabButton show={!showOnlyInfo} text={buttonText} hidden={disabled} onClick={onGrabClick} />
      </FooterWrap>
    </Wrapper>
  )
}

export default memo(BountyContent)
